import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "./auth.service";
import { CardPlans } from "../interfaces/serasa/card-plans";
import { ViaCep } from "../interfaces/via-cep.interface";
import { PaymentCreditCard, PaymentPix } from "../interfaces/serasa/payment.interface";
import { SerasaInquiryInterface } from "../interfaces/serasa/serasa-inquiry.interface";
import { SerasaHistoriesInterface } from "../interfaces/serasa/serasa-histories.interface";
import { ListResponseItems } from "../interfaces/list-response.interface";
import { AssasHistoriesInterface } from "../interfaces/serasa/assas-histories.interface";
import { StageCompliance } from "../interfaces/serasa/serasa.interface";

@Injectable({
  providedIn: "root"
})
export class ApiServiceSerasa {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) { }

  private optionsHeader = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: this.authenticationService.getBearerToken()
    })
  };

  getSerasaCnpj() {
    return this.http.get<any[]>("/serasa/status", this.optionsHeader);
  }

  getSerasaStatus() {
    return this.http.get<any>("/serasa", this.optionsHeader);
  }

  getManagerCompliance() {
    return this.http.get<any>("/manager/compliance", this.optionsHeader);
  }

  updateSerasaStatus(id: string) {
    return this.http.put<any[]>(`/serasa/${id}`, this.optionsHeader);
  }

  getAllPlans() {
    return this.http.get<CardPlans[]>("/asaas/plans", this.optionsHeader);
  }

  getPlans(id: string) {
    return this.http.get<CardPlans>(`/asaas/plans/${id}`, this.optionsHeader);
  }

  buyCreditCard(data: Object) {
    return this.http.post<PaymentCreditCard>(`/asaas/purchases/credit-card`, data, this.optionsHeader);
  }

  buyPix(data: Object) {
    return this.http.post<PaymentPix>(`/asaas/purchases/pix`, data, this.optionsHeader);
  }

  getStatusPix(plan_id) {
    return this.http.get<any>(`/asaas/purchases/pix/status?plan_id=${plan_id}`, this.optionsHeader);
  }

  getCep(cep: string) {
    return this.http.get<ViaCep>(`/via-cep/` + cep, this.optionsHeader);
  }

  createConsult(data: SerasaInquiryInterface) {
    return this.http.post<SerasaInquiryInterface>("/serasa/inquiry", data, this.optionsHeader);
  }

  getConsults() {
    return this.http.get<ListResponseItems<SerasaHistoriesInterface[]>>("/serasa/histories", this.optionsHeader);
  }

  getAllConsults() {
    return this.http.get<ListResponseItems<SerasaHistoriesInterface[]>>("/serasa/histories/all", this.optionsHeader);
  }

  getQuantityConsults() {
    return this.http.get<AssasHistoriesInterface>("/asaas/histories", this.optionsHeader);
  }

  getConsultsForIdAdmin(id: string) {
    return this.http.get<AssasHistoriesInterface>(`/asaas/histories/${id}`, this.optionsHeader);
  }
}
